// removed by extract-text-webpack-plugin
module.exports = {"tight":"tight__3L15l"};


//////////////////
// WEBPACK FOOTER
// ./components/VerbalChanges/style.css
// module id = dwC8
// module chunks = 0